import React from 'react'
import { Image } from 'newComponents'
import './styles.scss'

const Avatar = (props) => {
  const { avatar, fullName, jobTitle, lightText } = props

  return (
    <div className={lightText ? 'avatar-light' : 'avatar'}>
      <Image className="avatar-image" image={avatar} />
      <div>
        <p className={lightText ? 'avatar-full-name-light' : 'avatar-full-name'}>{fullName}</p>
        <p className={lightText ? 'avatar-job-title-light' : 'avatar-job-title'}>{jobTitle}</p>
      </div>
    </div>
  )
}

export default Avatar
